module.exports = __webpack_public_path__ + "img/7.d1090f80.jpg";